export default "__VITE_ASSET__DlZNyZd3__"